var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"notice-top"},[_vm._v(" 产品动态 ")]),_c('SpFinder',{ref:"finder",staticClass:"channelCode",attrs:{"id":"1","show-tool-bar":false,"no-selection":true,"url":{
      data: _vm.requestUrl + '/it/site/list?publish_status=1&type=2'
    },"setting":{
      search: [
        {
          type: 'input',
          key: 'title',
          name: '标题',
          size: 'medium',
          placeholder: '请输入标题'
        }
      ]
    },"title":"数据","columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }